import type { ContextNode } from "@/domain/types";

interface ContextSelectProps {
  contexts: ContextNode[];
  value: string;
  onChange: (id: string) => void;
}

/**
 * The flat-Context selector: a plain dropdown for a Game whose Contexts are a flat list -
 * Destiny 2's On Foot / Vehicle - distinct from StarCraft II's bespoke drill-down command card. The
 * caller hides it when a Game offers one Context or none. Reuses the command-card chrome so the two
 * Context surfaces read alike in the control bar.
 */
export function ContextSelect({ contexts, value, onChange }: ContextSelectProps) {
  return (
    <span className="command-card">
      <span className="command-card-label">Context</span>
      <select aria-label="Context" value={value} onChange={(e) => onChange(e.target.value)}>
        {contexts.map((c) => (
          <option key={c.id} value={c.id}>
            {c.label}
          </option>
        ))}
      </select>
    </span>
  );
}
